/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block}picture[_ngcontent-%COMP%]{display:block;margin:0 auto;width:100%;max-width:100%}.app-picture--ratio[_ngcontent-%COMP%]{padding-bottom:66.66666667%;height:0;overflow:hidden}img[_ngcontent-%COMP%]{max-width:100%;width:auto;height:auto}"];
export { styles as styles };
